import { Breadcrumb, Tabs } from "antd";
import { FC, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { lockSVG } from "../../assets/SVGs/SVGs";
import QuickActionButton from "../common/QuickActionButton";
import SalonLocationsSelect from "../common/SalonLocationsSelect";
import OnlineBookingSettings from "./OnlineBookingSettings/OnlineBookingSettings";
import Channels from "./channels/Channels";
import ClientsReviews from "./clientsReviews/ClientsReviews";
import DirectLinks from "./direct-links/DirectLinks";
import OnlinePresence from "./onlinePresence/OnlinePresence";
import OverView from "./overView/OverView";

interface OnlineBookingWrapperProps {}

const OnlineBookingWrapper: FC<OnlineBookingWrapperProps> = ({}) => {
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState("0");
  const handleChangeTab = (key: string) => {
    setTabIndex(key);
  };
  const intl = useIntl();
  const tabs = [
    {
      title: intl.formatMessage({ id: "overviewTitle" }),
      component: <OverView />,
    },
    {
      title: intl.formatMessage({ id: "onlinePresenceTitle" }),
      component: <OnlinePresence />,
    },
    {
      title: intl.formatMessage({ id: "directLinksTitle" }),
      component: <DirectLinks />,
    },
    {
      title: intl.formatMessage({ id: "channelsTitle" }),
      component: <Channels />,
      disabled: true,
    },
    {
      title: intl.formatMessage({ id: "clientsReviewsTitle" }),
      component: <ClientsReviews />,
    },
    {
      title: intl.formatMessage({ id: "onlineBookingSettingsTitle" }),
      component: <OnlineBookingSettings />,
      disabled: true,
    },
  ].map((item, i) => {
    const id = String(i);
    return {
      label: (
        <div
          className={
            "md:w-[120px] justify-center flex items-center gap-2 " +
            (i > 4 ? "text-#9999A7 " : "")
          }
        >
          <span> {i === 3 || i === 5 ? lockSVG : null}</span>
          {item.title}
        </div>
      ),
      key: id,
      children: item.component,
      disabled: item?.disabled, //Todo change it to the right condition
    };
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Breadcrumb
          separator=">"
          items={[
            {
              title: (
                <div className="text-[#75757E]">
                  {intl.formatMessage({
                    id: "Settings",
                    defaultMessage: "الإعدادات",
                  })}
                </div>
              ),
              href: "#",
              onClick: () => {
                navigate("/settings");
              },
            },
            {
              title: (
                <div className="text-color-primary">
                  {intl.formatMessage({
                    id: "onlineBooking",
                  })}
                </div>
              ),
            },
          ]}
        />

        <div>
          {/* Button commented out, if needed, uncomment and use */}
          {/* <Button type="primary" htmlType="button">
        {magicStick}
      </Button> */}
          <QuickActionButton iconOnly={false} />
        </div>
      </div>

      <div>
        <SalonLocationsSelect />
      </div>

      <div className="tabs-card-wrapper">
        <Tabs
          activeKey={tabIndex}
          onChange={handleChangeTab}
          type="card"
          items={tabs}
        />
      </div>
    </div>
  );
};

export default OnlineBookingWrapper;
